import { combineReducers } from 'redux';
import authReducer, { IAuthState } from './authReducer';
import newPasswordReducer, { INewPasswordState } from './newPasswordReducer';
import attachmentsReducer, { IAttachmentState } from './attachmentsReducer';
import { GetReducer, ICrudState } from './crud';
import { ECrudType } from 'redux/actions/crud';
import moment from 'moment';
import { getDurationDisplay } from 'components/atom/duration-dropdown';
import { IInvoiceState } from 'models';
import dashboardReducer, { IDashboardState } from './dashboardReducer';
import invoiceReducer from './invoiceReducer';
import { DATETIME_FORMAT } from 'utils/date';
import rateReducer from './rateReducer';
import shiftReducer from './shiftReducer';

export enum EReducer {
  invoices = 'invoices',
  expenses = 'expenses',
  shifts = 'shifts',
  contacts = 'contacts',
  rates = 'rates',
  states = 'states',
  countries = 'countries',
  organizationUsers = 'organizationUser',
}

export interface IState {
  auth: IAuthState;
  newPassword: INewPasswordState;

  attachments: IAttachmentState;
  [ECrudType.dashboard]: IDashboardState;
  [ECrudType.invoices]: IInvoiceState;
  [ECrudType.expenses]: ICrudState;
  [ECrudType.shifts]: ICrudState;
  [ECrudType.contacts]: ICrudState;
  [ECrudType.rates]: ICrudState;
  [ECrudType.states]: ICrudState;
  [ECrudType.countries]: ICrudState;
  [ECrudType.agreements]: ICrudState;
  [ECrudType.users]: ICrudState;
  [ECrudType.organizationUsers]: ICrudState;
}

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  newPassword: newPasswordReducer,
  attachments: attachmentsReducer,
  contacts: GetReducer(ECrudType.contacts, (obj: any) => ({
    ...obj,
    dob: obj.dob ? moment(obj.dob) : undefined,
  })),
  rates: rateReducer,
  shifts: shiftReducer,
  expenses: GetReducer(ECrudType.expenses, (obj: any) => ({
    ...obj,
    date: moment(obj.date),
    idContact: obj.idContact?.toString(),
    ...(obj.shift
      ? {
          shift: {
            ...obj.shift,
            dropdown: `${moment(obj.shift.startDate).format(DATETIME_FORMAT)} - ${getDurationDisplay(obj.shift.duration / 60)}`,
          },
        }
      : undefined),
  })),
  invoices: invoiceReducer,
  agreements: GetReducer(ECrudType.agreements, (obj: any) => ({
    ...obj,
    startDate: moment(obj.startDate),
    endDate: moment(obj.endDate),
    reviewDate: moment(obj.reviewDate),
    completedAt: moment(obj.completedAt),
  })),
  states: GetReducer(ECrudType.states),
  countries: GetReducer(ECrudType.countries),
  organizationUsers: GetReducer(ECrudType.organizationUsers),
});

export default rootReducer;
